import { useEffect, useState } from "react";
import { useWeb3React } from "@web3-react/core";
import { VotingEscrowFactory } from "../codegen/VotingEscrowFactory";
import { VotingEscrowAddress } from "../constants/constants";
export var getVotingEscrow = function (library) {
    if (library) {
        var provider = library.getSigner();
        return VotingEscrowFactory.connect(VotingEscrowAddress, provider);
    }
    return undefined;
};
var useVotingEscrow = function () {
    var _a = useWeb3React(), library = _a.library, active = _a.active;
    var _b = useState(), contract = _b[0], setContract = _b[1];
    useEffect(function () {
        setContract(getVotingEscrow(library));
    }, [library, active]);
    return contract;
};
export default useVotingEscrow;
//# sourceMappingURL=useVotingEscrow.js.map